import { IRootReducer } from '../rootReducer';

export const getBills = (state: IRootReducer) => state.bills.bills;
export const getBillSelected = (state: IRootReducer) => state.bills.billSelected;
export const getBillsSelected = (state: IRootReducer) => state.bills.billsSelected;
